import {CustomPlayer} from './CustomPlayer';
import {TimeoutPromise} from '../promises/TimeoutPromise';

type VideoControls={
    pip: JQuery<HTMLElement>,
    fullscreen: JQuery<HTMLElement>
};

export class VideoPlayer extends CustomPlayer {

    protected videoControls:VideoControls;

    constructor (protected container:JQuery) {
        super(container, (container.find('video') as JQuery<HTMLVideoElement>));

        let controls = this.container.find('.controls');
        controls.hover(()=>this.noTimeOut = true, ()=>{this.noTimeOut = false; this.timeoutControl()});
        controls.focusin(()=>this.noTimeOut = true).focusout(()=>this.noTimeOut = false);

        this.element.on("click keydown",(e)=>{
            this.togglePlay(e);
            this.textSwitch(this.element);
        });

        this.videoControls = {
            pip: this.container.find('.pip'),
            fullscreen: this.container.find('.fullscreen')
        };

        // PIP
        if ((this.element[0] as any).requestPictureInPicture) {
            this.videoControls.pip.click((e)=>{
                this.togglePictureInPicture(e);
                this.textSwitch(this.videoControls.pip);
            });
        } else {
            this.videoControls.pip.remove();
        }

        this.videoControls.fullscreen.click((e)=>{
            this.toggleFullscreen(e);
            this.textSwitch(this.videoControls.fullscreen);
        });

        // native Kontrollelemente für Fullscreen (ändern nicht alle per default)
        if (this.container[0].requestFullscreen!==undefined) {
            this.container[0].addEventListener('fullscreenchange', ()=>this.fullscreenChange());
        } else if ((this.container[0] as any).mozRequestFullScreen) {
            this.container[0].addEventListener('mozfullscreenchange', ()=>this.fullscreenChange());
        } else if ((this.container[0] as any).webkitRequestFullscreen) {
            this.container[0].addEventListener('webkitfullscreenchange', ()=>this.fullscreenChange());
        }

        if ("orientation" in screen) {
            $(screen.orientation).on("change", (e) =>{
                if(this.isPlaying && (screen.orientation.type == 'landscape-primary' || screen.orientation.type == 'landscape-secondary') ) {
                    this.toggleFullscreen(e);
                    this.play(e);
                }
            });
        }
    }

    public togglePlay(e:JQuery.TriggeredEvent) {
        super.togglePlay(e);

        if(this.controls) this.controls.play.removeClass('restart').toggleClass('play', this.isPlaying).toggleClass('pause', !this.isPlaying);
    };

    public async togglePictureInPicture(e:JQuery.TriggeredEvent) {
        let val=this.element.attr('disablepictureinpicture');
        this.element.removeAttr('disablepictureinpicture');
        (this.element[0] as any).requestPictureInPicture();
        await new TimeoutPromise(100);
        this.element.attr('disablepictureinpicture',val??null);
    }

    public toggleFullscreen(e:JQuery.TriggeredEvent) {
        if(e.type=="keydown" && e.key != " " && e.key != "Enter") {
            return;
        } else {
            e.preventDefault();
        }

        if(!this.videoControls.fullscreen.hasClass('active')) {
            if (this.container[0].requestFullscreen!==undefined) {
                this.container[0].requestFullscreen();
            } else if ((this.container[0] as any).mozRequestFullScreen) {
                (this.container[0] as any).mozRequestFullScreen();
            } else if ((this.container[0] as any).webkitRequestFullscreen) {
                (this.container[0] as any).webkitRequestFullscreen();
            } else {
                this.customFullScreen(true);
            }
        } else {
            if ((document as any).cancelFullScreen) {
                (document as any).cancelFullScreen();
            } else if ((document as any).mozCancelFullScreen) {
                (document as any).mozCancelFullScreen();
            } else if ((document as any).webkitCancelFullScreen) {
                (document as any).webkitCancelFullScreen();
            } else {
                this.customFullScreen(false);
            }
        }
    }

    protected customFullScreen(state:boolean) {
        this.container.toggleClass('custom-fullscreen', state);
        $('body').css('overflow-y',state?'hidden':'');
        this.fullscreenChange();

        document.addEventListener('keydown', (e) => {
            if (e.key != "Esc") return;
            this.customFullScreen(false);
        });
    }

    protected fullscreenChange() {
        let isActive = !this.videoControls.fullscreen.hasClass('active');
        this.container.toggleClass("active-fullscreen", isActive);
        this.videoControls.fullscreen.toggleClass("active", isActive);
    }

    protected timeUpdate(e:JQuery.TriggeredEvent) {
        super.timeUpdate(e);

        if(!this.changing && e.type != 'timeupdate') {
            this.changing = e.type == 'input';
            if(this.changing) this.timeoutControl();
        }
    };
}

export {};